import React, { Component } from 'react'
import { Checkbox } from 'semantic-ui-react'

export default function CheckboxInput({
  value,
  name,
  label,
  id,
  onChange,
  onBlur,
  disabled,
  referenceConfig,
  formState,
  inputLabel,
  ...customProps
}) {
  return (
    <Checkbox
      {...customProps}
      name={name}
      checked={value || false}
      disabled={disabled}
      onChange={e => onChange({ name, value: value !== true })}
      label={inputLabel}
    />
  )
}
